import React from "react";
import styles from "./WhyUs.module.scss";

const WhyUs = () => {
  const platformComparison = {
    title: "Why leading brands choose Socommerz B2B",
    subtitle: "Multi-vendor marketplace solution",
    keyFunctions: [
      {
        title: "End-to-end operations",
        features: [
          "Unlike other partial solutions, Socommerz unifies storefronts, orders, payments, and logistics in one platform",
        ],
      },
      {
        title: "Headless B2B",
        features: [
          "Plug into any front-end or channel without disrupting your existing backend systems",
        ],
      },
      {
        title: "Mobile-optimized",
        features: [
          "Enable buyers to place orders, get real-time updates and access all platform features on their mobile",
        ],
      },

      {
        title: "Enterprise-grade security",
        features: [
          "ISO/IEC 27001 certified platform for secure, compliant and reliable operations",
        ],
      },
      {
        title: "Flexible integrations",
        features: [
          "Integrate with existing ERP, CRM, POS, OMS, logistics systems without disrupting your current operations",
        ],
      },
      {
        title: "Automated and intuitive workflows",
        features: [
          "Replace fragmented, manual tasks with automated B2B ordering, bulk uploads and simplified digital processes",
        ],
      },
    ],
  };

  return (
    <section className={styles["platform-section"]}>
      <div className={styles["platform-container"]}>
        <div className={styles["platform-header"]}>
          <h2 className="heading">Why brands choose Socommerz B2B</h2>
        </div>

        <div className={styles["platform-card"]}>
          <div className={styles["platform-grid"]}>
            {platformComparison.keyFunctions.map((func, index) => (
              <div key={index} className={styles["why-card"]}>
                <div className={styles["why-number"]}>
                  {String(index + 1).padStart(2, "0")}
                </div>

                <h4 className={styles["why-title"]}>{func.title}</h4>

                {func.features.map((feature, fidx) => (
                  <p key={fidx} className={styles["why-description"]}>
                    {feature}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
